<div id="forms" class="page-layout simple fullwidth" fxLayout="column">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button class="mr-16" (click)="regresarDetail()">
                    <mat-icon>arrow_back</mat-icon>
            </button>
            <h1 class="m-0">{{'PERFILES.EMPRESA.CLOUD' | translate}}</h1>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card p-20">
          <div fxLayout="row" fxLayoutAlign="center">
            <h1>{{nombreEmpresa}}</h1>
          </div>
          <div *ngIf="!guardandoArchivo && enRaiz == false" class="uploadfilecontainer" (click)="fileInput.click()" appDropFile
            (onFileDropped)="uploadFile($event)"
            [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <input hidden type="file" #fileInput id="inputFile" (change)="onFileChange($event)">
            <h1>{{'FILEMANAGER.CARGA.TITULO' | translate}}</h1>
          </div>

          <div *ngIf="guardandoArchivo" class="mt-20" fxLayout="row" fxLayoutAlign="space-around stretch">
            <!--- guardando registros en back --->
            <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
              [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
              <h2 class="mt-0">{{'FILEMANAGER.CARGA.CARGANDOTIT' | translate}}</h2>
              <mat-divider></mat-divider>
              <div class="mt-20 mb-20">
                <div class="h4 secondary-text">{{'FILEMANAGER.CARGA.CARGANTOTXT' | translate}}</div>
                <mat-progress-bar mode="buffer" [value]="progresoCarga" class="barraCarga mt-20"></mat-progress-bar>
              </div>
            </div>
          </div>
          <tablaArchivos
          [datosEmpresa]="datosEmpresa"
          [actualizaArchivos] = "eventsSubject.asObservable()"
          (enviaIdCarpeta)="setIdCarpetaActual($event)"
          (direccionActual)="setDireccionActual($event)"
          (archivoNuevo)="onFileChange($event)"
          (tipoCloudNuevo)="versionCloudNueva = $event"
          (statusRaiz)="enRaiz = $event"
          ></tablaArchivos>
        </div>
    </div>
</div>
